
export const MessageUtil = {


    parseItalic(value: string): string {
        const expr = /(?:\_)([^_]+)(?:\_)/g;
        if (expr.test(value)) {
          return value.replace(expr, '<i>$1</i>');
        }
        return value;
    },
    parseStrike(value: string): string {
        const expr = /(?:\~)([^~]+)(?:\~)/g;
        if (expr.test(value)) {
          return value.replace(expr, '<strike>$1</strike>');
        }
        return value;
    },
    parseBold(value: string): string {
        const expr = /(?:\*)([^*]+)(?:\*)/g;
        if (expr.test(value)) {
          return value.replace(expr, '<strong>$1</strong>');
        }
    
        return value;
    },
    parseURL(value: string): string {
        const expr = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
        if (expr.test(value)) {
          return value.replace(expr, '<a href="$1" class="white-link" target="_blank">$1</a>');
        }
        return value;
    },
    parseNewLine(value: string): string {
        const expr = /\n\t\r|\n|\t|\r/g;
        if (expr.test(value)) {
          return value.replace(expr, '<br>');
        }
    
        return value;
    },

    format: (message: string) => {
        message = MessageUtil.parseItalic(message);
        message = MessageUtil.parseStrike(message);
        message = MessageUtil.parseBold(message);
        message = MessageUtil.parseURL(message);
        message = MessageUtil.parseNewLine(message);
    
        return message;
    },

    
}